export const APP_LAUNCHED = 'APP_LAUNCHED'
export const STORE_SEARCH_URL = 'STORE_SEARCH_URL'
export const MEDIA_ACCESS_ALLOWED = 'MEDIA_ACCESS_ALLOWED'
export const CREATE_NEW_ACCOUNT_PRESSED = 'CREATE_NEW_ACCOUNT_PRESSED'
export const ONE_TIME_SMS_LOGIN = 'ONE_TIME_SMS_LOGIN'
export const RESET_PASSWORD_PRESSED = 'RESET_PASSWORD_PRESSED'
export const USER_LOGGED_IN_SUCCSESSFULY = 'USER_LOGGED_IN_SUCCSESSFULY'
export const SHOW_APP_DOWNLOAD_LINK_POP_UP = 'SHOW_APP_DOWNLOAD_LINK_POP_UP'
export const ENABLE_DOWNLOAD_LINK_BUTTON = 'ENABLE_DOWNLOAD_LINK_BUTTON'
export const CLOSE_APP_DOWNLOAD_LINK_POP_UP = 'CLOSE_APP_DOWNLOAD_LINK_POP_UP'
export const ANALYTICS_INITIATED = 'ANALYTICS_INITIATED'
export const REMOTE_CONFIG_RECEIVED = 'REMOTE_CONFIG_RECEIVED'
export const FEATURE_ENABLED = 'FEATURE_ENABLED'
export const VALIDATE_STATE_RECEIVED_EXTERNAL =
  'VALIDATE_STATE_RECEIVED_EXTERNAL'
export const MESSAGE_DISPLAYED = 'MESSAGE_DISPLAYED'
export const MESSAGE_DISPLAY_APPROVED = 'MESSAGE_DISPLAY_APPROVED'
export const CLEAR_ALERT = 'CLEAR_ALERT'
export const SYSTEM_LANGUAGES_REQUESTED = 'SYSTEM_LANGUAGES_REQUESTED'
export const SYSTEM_LANGUAGES_RECEIVED = 'SYSTEM_LANGUAGES_RECEIVED'
export const HMO_WELCOME_DIALOG_CLOSED = 'HMO_WELCOME_DIALOG_CLOSED'
export const RISK_ASSESMENT_BOT_COMPLETED_CLOSED =
  'RISK_ASSESMENT_BOT_COMPLETED_CLOSED'
export const SHOW_HMO_PRIVACY_CONCENT_DIALOG = 'SHOW_HMO_PRIVACY_CONCENT_DIALOG'
export const HMO_PRIVACY_CONCENT_AGREED = 'HMO_PRIVACY_CONCENT_AGREED'
export const CLOSE_HMO_PRIVACY_CONCENT_DIALOG =
  'CLOSE_HMO_PRIVACY_CONCENT_DIALOG'
export const NEW_PROVIDER_DIRECTORY_DIALOG_CLOSED =
  'NEW_PROVIDER_DIRECTORY_DIALOG_CLOSED'
